import { html, View } from 'rune-ts';

interface AbstractLoadingViewOption {
  // 초기 활성화 여부
  initial_active?: boolean;

  container_klass: string;
  loading_klass: string;
  hidden_klass: string;
}

export abstract class AbstractLoadingView extends View<Readonly<AbstractLoadingViewOption>> {
  protected active: boolean;

  constructor(option: Readonly<AbstractLoadingViewOption>) {
    super(option);
    this.active = option.initial_active ?? false;
  }

  protected override template() {
    const { container_klass, loading_klass, hidden_klass } = this.data;
    return html` <div class="${container_klass} ${this.active ? '' : hidden_klass}">
      <div class="${loading_klass}"></div>
    </div>`;
  }

  protected setActive(value: boolean) {
    this.active = value;
  }

  public abstract show(): void;

  public abstract hide(): void;

  protected setElementVisibility(visible: boolean): void {
    const { hidden_klass } = this.data;
    if (visible) {
      this.element().classList.remove(hidden_klass);
    } else {
      this.element().classList.add(hidden_klass);
    }
  }
}
